export const lxyLangAr = {
    dashbordlxy: { welcome: 'welcome log in to the system' },
    menuLxy: {
        lawyerFirmList: 'firm page'
    },
    lawyerLxy: {
        LawyerLetter: "Lawyer's letter status",
        LawyerStatus_UNDSend: "unsent", // 未发送
        LawyerStatus_Cancel: "withdraw", // 撤回
        change: 'change state',
        sendToOther: "not forwarded third party Lawyer's letter",
        Applycounts: "number of application"
    },
    dataModulelxy: {
        dataModule: 'data module',
        dataList: "ticket data",
        anomalyStatistics: "anomaly statistics",
        loginOrnot: 'Is logged in',
        KeyIndicators: 'Key Performance Indicator（KPI）',
        AuditCompleted: 'Audit completed',
        uncomplete: 'UnComplete',
        passAmount: 'pass the amount',
        invalidAmount: 'failure the amount',
        rejectAmount: 'rejection the amount',
        passRate: 'pass rate',
        invalidRate: 'failure rate',
        rejectRate: 'rejection rate',
        QualityCheckAmount: ' Amount of quality inspection',
        QualitypassAmount: 'pass volume of quality inspection',
        QualityjectAmount: 'Rejected quantity of quality inspection',
        GenerateTicketAmount: 'Number of tickets generated',
        assignmentTicketAmount: 'Number of Assigned ticket',
        finishTicketAmount: 'Number of completed ticket',
        passAmountAndRate: 'pass the amount and proportion',
        overruleAmountAndRate: 'failure the amount and proportion',
        rejectAmountAndRate: 'rejection the amount and proportion',
        QualitypassAmountAndRate: 'pass volume of quality inspection and proportion',
        QualityCheck: 'Quality check',
        EveryItemTime: 'Processing time per piece',
        RankEmployeesGroup: 'Rank of employees in the group',
        TeamData: 'Team Data',
        avgHandleTicketNum: 'Processing volume per-capita',
        avgAnswerNum: 'Number of connected call per-capita',
        avgClosureAmount: 'Per-capita amount',
        newOnceClosureNum: 'New ticket one transaction',
        newNotOnceClosureNum : 'new ticket non-single transaction',
        oldClosureNum: 'Old ticket',
        otherClosureNum: 'Other',
        dailyClosureMetrics: 'finish volume/amount/rate',
    }
};